"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateChildren = exports.translate = void 0;
const translator_table_1 = require("./translator-table");
function translate(chunk, actions = new Map()) {
    const label = chunk.props.label ? `${chunk.props.label}: ` : "";
    let pattern = "__undefined__";
    if (chunk.tagName) {
        const key = chunk.tagName;
        const Translator = translator_table_1.TranslatorTable[key];
        pattern = new Translator().translate(chunk, actions);
    }
    else {
        pattern = chunk.rule.name;
    }
    return `${label}${pattern}`;
}
exports.translate = translate;
function translateChildren(chunk, actions) {
    return chunk.children.map(child => translate(child, actions));
}
exports.translateChildren = translateChildren;
